import {Box, Button, CircularProgress, IconButton, Stack} from "@mui/material";
import {useEffect, useState} from "react";
import {FiEdit2, FiTrash2} from "react-icons/fi";
import {useLocation, useNavigate} from "react-router-dom";
import ListView from "../components/ListView/ListView";
import RoleForm from "../components/Roles/RoleForm";
import RoleInfo from "../components/Roles/RoleInfo";
import Window from "../components/Window/Window";
import ConfirmDialog from "../components/ui/ConfirmDialog";
import {userColumns} from "../constants/dataGridColumns";
import useApiRequest from "../hooks/useApiRequest";
import useConfirmDialog from "../hooks/useConfirmDialog";

const RoleDetail = () => {
  const {state} = useLocation();
  const navigate = useNavigate();
  const id = state?.id;

  const isNewRole = !id;

  const {data, loading, read, remove} = useApiRequest({baseUrl: `/roles`, resource: "roles"});

  const {
    data: users,
    loading: loadingUsers,
    list
  } = useApiRequest({baseUrl: `/roles/${id}/users`, resource: "roles", field: "users"});

  const [isEditing, setIsEditing] = useState(isNewRole);

  // Hook para el diálogo de confirmación
  const {confirmOpen, itemName, openDialog, handleConfirm, handleCancel} = useConfirmDialog(async () => {
    try {
      await remove(id);
      navigate("/roles");
    } catch (error) {
      console.error("Error al eliminar el rol:", error);
    }
  });

  useEffect(() => {
    if (!isNewRole) {
      (async () => {
        try {
          await read(id);
          await list();
        } catch (error) {
          console.error("Error al cargar los detalles del rol:", error);
        }
      })();
    }
    // eslint-disable-next-line
  }, [id]);

  const handleEditToggle = () => {
    setIsEditing(!isEditing);
  };

  const handleOpenDeleteDialog = () => {
    openDialog(id, data?.name || "");
  };

  return (
    <>
      <Window title={isNewRole ? "Nuevo Rol" : "Detalles del Rol"}>
        {loading && !isNewRole ? (
          <CircularProgress />
        ) : (
          <>
            <Stack direction="row" spacing={2} justifyContent={"space-between"}>
              {isEditing ? (
                <RoleForm
                  isNew={isNewRole}
                  refreshData={async () => {
                    try {
                      await read(id);
                    } catch (error) {
                      console.error("Error al cargar los detalles del rol:", error);
                    }
                  }}
                  setIsEditing={setIsEditing}
                  initialRoleData={data}
                />
              ) : (
                <RoleInfo role={data} />
              )}
              <Box>
                {!isNewRole &&
                  (isEditing ? (
                    <Button variant="contained" color="primary" onClick={handleEditToggle}>
                      Cancelar
                    </Button>
                  ) : (
                    <IconButton aria-label="edit" color="primary" onClick={handleEditToggle}>
                      <FiEdit2 />
                    </IconButton>
                  ))}
                {!isNewRole && (
                  <IconButton aria-label="delete" color="secondary" onClick={handleOpenDeleteDialog}>
                    <FiTrash2 />
                  </IconButton>
                )}
              </Box>
            </Stack>

            {!isNewRole && (
              <ListView viewTitle={`Usuarios`} columns={userColumns} data={users} loading={loadingUsers} />
            )}
          </>
        )}
      </Window>

      <ConfirmDialog
        open={confirmOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        entityName="rol"
        entityLabel={itemName}
      />
    </>
  );
};

export default RoleDetail;
